import React from "react";
import TotalUsers from "./TotalUsers";
import LastSignup from "./LastSignup";
import LastUserLogin from "./LastUserLogin";
import LastDDSearch from "./LastDDSearch";

const ActivityReportWidgets = () => {
  return (
    <React.Fragment>
      <div className="col-xl-12">
        <div className="card crm-widget">
          <div className="card-body p-0">
            <div className="row row-cols-xxl-4 row-cols-md-3 row-cols-1 g-0">
              <TotalUsers />
              <LastSignup />
              <LastUserLogin />
              <LastDDSearch />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ActivityReportWidgets;
